<div *ngIf="premiumDataLoaded">
<div class="heading-row-line"> <a (click)="navigateToPremiumData()" class="view-more-link">
            Click Here
        </a> to view Premium Report</div>
    <table class="table table-hover align-middle">

        <thead>
            <tr>
                <th><strong>Premium</strong></th>
                <th><strong>Value</strong></th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="label">{{ 'premium.direct' | label }}</td>
                <td class="value">{{ (direct_premium) | number:'1.0-0' }}</td>
            </tr>
            <tr>
                <td class="label">{{ 'premium.supplemental' | label }}</td>
                <td class="value">{{ (supplemental_premium) | number:'1.0-0' }}</td>
            </tr>
            <tr>
                <td class="label">{{ 'premium.userDefinedDirect' | label }}</td>
                <td class="value">{{ (userdefined_premium) | number:'1.0-0' }}</td>
            </tr>
            <tr>
                <td class="label">{{ 'premium.userDefinedSupplemental' | label }}</td>
                <td class="value">{{ (userdefined_premium_supplemental) | number:'1.0-0' }}</td>
            </tr>
            <tr>
                <td class="label total-row">Total Premium</td>
                <td class="value total-row">{{total_premium | number:'1.0-0'}}</td>
            </tr>
        </tbody>
    </table>
    
</div>